module.exports = __webpack_public_path__ + "img/next-track-button.50326ccd.png";